import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../services/ProcessamentoService";
export default {
    name: "ImportarRepasses",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Repasses Orçamentários',
                disabled: false
            },
            {
                text: 'Importar Repasses',
                disabled: true
            }
        ],
        arquivo: null,
        loading: false,
        uploadProgress: null,
        blockInputFile: false,
        scheduledList: [],
        isDragOver: false
    }),
    created() {
        this.loadScheduledList();
    },
    methods: {
        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('repasse');
            this.scheduledList = scheduledList.data;
        },
        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },
        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },
        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'repasse');

            ProcessamentoService.store(formData)
                .then(response => {

                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
                this.blockInputFile = false;
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.arquivo = file;
                this.uploadFile();
            }
        },
        handleDragOver(event) {
            event.preventDefault();
            this.isDragOver = true;
        },
        handleDragLeave(event) {
            event.preventDefault();
            this.isDragOver = false;
        },
        handleFileDrop(event) {
            event.preventDefault();
            this.isDragOver = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.arquivo = file;
                this.uploadFile();
            }
        },
        getStatusChipColor(item) {
            if (!item.processado) {
                return 'orange';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getStatusTextColor() {
            return 'white';
        },
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },
        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },
        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },
        getStatusColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },
        getErrorSummary(erro) {
            if (!erro) return '';
            
            const lines = erro.split('\n');
            const firstLine = lines[0] || '';
            
            const errorCount = (erro.match(/Erro #\d+:/g) || []).length;
            
            if (errorCount > 0) {
                return `${errorCount} erro(s) encontrado(s) durante o processamento`;
            }
            
            if (firstLine.length > 100) {
                return firstLine.substring(0, 100) + '...';
            }
            
            return firstLine;
        },
        parseErrors(erro) {
            if (!erro) return [];
            
            const errors = [];
            const errorBlocks = erro.split(/Erro #\d+:/);
            
            errorBlocks.forEach((block, index) => {
                if (index === 0 && !block.trim()) return;
                
                const lines = block.trim().split('\n');
                let linha = 0;
                let motivo = '';
                let dados = {};
                
                lines.forEach(line => {
                    const trimmedLine = line.trim();
                    
                    if (trimmedLine.startsWith('Linha:')) {
                        linha = parseInt(trimmedLine.replace('Linha:', '').trim()) || 0;
                    } else if (trimmedLine.startsWith('Motivo:')) {
                        motivo = trimmedLine.replace('Motivo:', '').trim();
                    } else if (trimmedLine.startsWith('Dados:')) {
                        const dadosStr = trimmedLine.replace('Dados:', '').trim();
                        try {
                            dados = JSON.parse(dadosStr);
                        } catch (e) {
                            dados = { raw: dadosStr };
                        }
                    }
                });
                
                if (motivo || Object.keys(dados).length > 0) {
                    errors.push({
                        linha: linha,
                        motivo: motivo || 'Erro não especificado',
                        dados: dados
                    });
                }
            });
            
            if (errors.length === 0 && erro.trim()) {
                errors.push({
                    linha: 0,
                    motivo: erro.substring(0, 200),
                    dados: {}
                });
            }
            
            return errors;
        },
        formatFieldName(key) {
            const fieldNames = {
                '0': 'Coluna 1',
                '1': 'Coluna 2',
                '2': 'Código',
                '3': 'Coluna 4',
                '4': 'Coluna 5',
                '5': 'Coluna 6',
                '6': 'Coluna 7',
                '7': 'Fonte',
                '11': 'GMIFP',
                '23': 'Programa',
                '25': 'Ação',
                '27': 'Sub-função',
                '29': 'Sub-ação',
                '33': 'Unidade Destino',
                '34': 'Unidade Origem',
                '41': 'Valor',
                'exercicio_id': 'Exercício',
                'programa_id': 'Programa',
                'grupo_id': 'Grupo',
                'elemento_id': 'Elemento',
                'elemento_item_id': 'Item',
                'fonte_id': 'Fonte',
                'unidade_executora_destino_id': 'Unidade Destino',
                'unidade_executora_origem_id': 'Unidade Origem',
                'acao_id': 'Ação',
                'ipu_id': 'IPU',
                'ipg_id': 'IPG',
                'valor': 'Valor',
                'data_repasse': 'Data Repasse',
                'codigo_repasse': 'Código Repasse'
            };
            
            return fieldNames[key] || key;
        },
    }
};